// export const API_URL_USER = "https://api-dev.insee.com/";
// export const API_URL_ADMIN = "https://api-dev.insee.com/mds/";
// export const API_URL_ADD_USER = "https://api-dev.insee.com/as/";
// export const API_URL_VPS = "https://api-dev.insee.com/vps/";
// export const API_URL_OMS = "https://api-dev.insee.com/oms/";
// export const API_URL_AMS = "https://api-dev.insee.com/ams/";
// export const API_URL_UMS = "https://api-dev.insee.com/ums/";
// export const API_URL_LMS = "https://api-dev.insee.com/lms/";

// export const API_URL_USER = "https://api-qat.insee.com/";
// export const API_URL_ADMIN = "https://api-qat.insee.com/mds/";
// export const API_URL_ADD_USER = "https://api-qat.insee.com/as/";
// export const API_URL_VPS = "https://api-qat.insee.com/vps/";
// export const API_URL_OMS = "https://api-qat.insee.com/oms/";
// export const API_URL_AMS = "https://api-qat.insee.com/ams/";
// export const API_URL_UMS = "https://api-qat.insee.com/ums/";
// export const API_URL_LMS = "https://api-qat.insee.com/lms/";


// export const API_URL_USER = '/';
// export const API_URL_ADMIN = '/mds/';
// export const API_URL_ADD_USER = '/as/';
// export const API_URL_VPS = '/vps/';
// export const API_URL_OMS = '/oms/';
// export const API_URL_AMS = '/ams/';
// export const API_URL_UMS = "/ums/";
// export const API_URL_LMS = "/lms/";

// export const API_URL_USER = "https://uat.insee.com/";
// export const API_URL_ADMIN = "https://uat.insee.com/mds/";
// export const API_URL_ADD_USER = "https://uat.insee.com/as/";
// export const API_URL_VPS = "https://uat.insee.com/vps/";
// export const API_URL_OMS = "https://uat.insee.com/oms/";
// export const API_URL_AMS = "https://uat.insee.com/ams/";
// export const API_URL_UMS = "https://uat.insee.com/ums/";
// export const API_URL_LMS = "https://uat.insee.com/lms/";

export const API_URL_USER = 'https://api.insee.com/';
export const API_URL_ADMIN = 'https://api.insee.com/mds/';
export const API_URL_ADD_USER = 'https://api.insee.com/as/';
export const API_URL_VPS = 'https://api.insee.com/vps/';
export const API_URL_OMS = 'https://api.insee.com/oms/';
export const API_URL_AMS = 'https://api.insee.com/ams/';
export const API_URL_UMS = 'https://api.insee.com/ums/';
export const API_URL_LMS = 'https://api.insee.com/lms/';
